import GeneralServices from "./GeneralServices";

class PortalFormacionServices {
  getList= async (
    setLoading: Function,
    loader: boolean,
    code: string
  )=> {
    try {
      const response = await GeneralServices.get({
        setLoading,
        loader,
        endpoint: `portal-formacion/${code}`,
      });
      return response.data;
    } catch (err) {
      throw err;
    }
  };
}
export default new PortalFormacionServices();
